/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Handle, Position } from '@xyflow/react'
import { IoLogoJavascript } from 'react-icons/io5'
import { Box } from '@chakra-ui/react'
import { marked } from 'marked'
import hljs from 'highlight.js'
import { useEffect } from 'react'

function TransformationNode({ data, isConnectable }) {
  useEffect(() => {
    hljs.highlightAll()
  })

  return (
    <>
      <Box className="custom-node-datahub node-transform">
        <div className="node-header">
          <IoLogoJavascript size={20} />
          <span>Transformation</span>
        </div>
        <div className="node-content">
          <div className="node-section">
            <div className="node-label">JavaScript Function</div>
            {/* biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation> */}
            <div dangerouslySetInnerHTML={{ __html: marked(data?.script) }} />
          </div>
        </div>
      </Box>
      <Handle type="source" position={Position.Right} />
      <Handle type="target" position={Position.Left} />
    </>
  )
}

export default TransformationNode
